import { TextBase } from '@carboncopyco/ui';

export const TableEmptyState = () => (
  <div className="flex flex-col items-center justify-center gap-2 h-full">
    <TextBase
      label="Hang tight!"
      color="text-ds-natural-600"
    />
    <div className="text-center">
      <TextBase
        label="Once activity occurs, data will appear here."
        color="text-ds-natural-400"
      />
    </div>
  </div>
);
